var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCipLease({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-CIP_Lease"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CIP_Lease",
    "data-name": "CIP Lease",
    clipPath: "url(#clip-CIP_Lease)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11752",
    "data-name": "Group 11752",
    transform: "translate(2.128 0.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11753",
    "data-name": "Group 11753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22175",
    "data-name": "Path 22175",
    d: "M12.238,17.5H1.508a.458.458,0,0,0-.077-.03A1.623,1.623,0,0,1,0,15.736Q0,11.61,0,7.483c0-1.151,0-2.3,0-3.452A1.725,1.725,0,0,1,1.478,2.325a11.928,11.928,0,0,1,1.261-.036c.192,0,.384,0,.591,0,0-.2,0-.371,0-.546,0-.371.111-.486.489-.491.336,0,.672-.008,1.008,0A.224.224,0,0,0,5.066,1.1,1.847,1.847,0,0,1,6.863,0,1.826,1.826,0,0,1,8.648,1.114a.2.2,0,0,0,.215.139c.376-.006.752-.008,1.127,0,.31.01.425.143.426.451,0,.191,0,.381,0,.581.547,0,1.064-.008,1.582,0a1.759,1.759,0,0,1,1.746,1.775q0,5.887,0,11.773a1.539,1.539,0,0,1-.976,1.488,4.268,4.268,0,0,1-.531.171M3.33,3.13c-.562,0-1.108-.02-1.652.006a.9.9,0,0,0-.848.941q0,5.878,0,11.755a.717.717,0,0,0,.51.745,1.578,1.578,0,0,0,.517.085q5.013.007,10.027,0a1.961,1.961,0,0,0,.323-.024.788.788,0,0,0,.709-.838q0-5.843,0-11.687a.934.934,0,0,0-.98-.993c-.455-.005-.911,0-1.366,0-.045,0-.089.007-.154.012,0,.3,0,.6,0,.891,0,.389-.162.554-.546.554H3.856c-.369,0-.526-.16-.526-.533,0-.3,0-.6,0-.916M9.567,2.082H8.492a.47.47,0,0,1-.521-.391A1.179,1.179,0,0,0,6.858.773a1.2,1.2,0,0,0-1.145.906.464.464,0,0,1-.527.4H4.177V3.741h5.39Z",
    transform: "translate(0 0)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22176",
    "data-name": "Path 22176",
    d: "M179.317,201.508h-2.236a1.376,1.376,0,0,1-.221-.012.411.411,0,0,1-.059-.794.75.75,0,0,1,.218-.027q2.312,0,4.625,0a.716.716,0,0,1,.234.035.411.411,0,0,1-.071.784,1.25,1.25,0,0,1-.221.014h-2.27",
    transform: "translate(-170.478 -193.802)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22177",
    "data-name": "Path 22177",
    d: "M179.333,395.323c.757,0,1.513,0,2.27,0a.864.864,0,0,1,.252.031.411.411,0,0,1-.041.786,1.043,1.043,0,0,1-.22.02h-4.54a1.148,1.148,0,0,1-.2-.015.411.411,0,0,1-.024-.8.955.955,0,0,1,.22-.019h2.287",
    transform: "translate(-170.469 -381.786)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22178",
    "data-name": "Path 22178",
    d: "M179.311,298.092q1.16,0,2.321,0a.416.416,0,0,1,.122.824.644.644,0,0,1-.1.005q-2.355,0-4.71,0a.416.416,0,0,1-.447-.337.4.4,0,0,1,.41-.489c.415-.008.83,0,1.246,0h1.16",
    transform: "translate(-170.444 -287.883)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22179",
    "data-name": "Path 22179",
    d: "M62.2,269.529c.4-.377.808-.776,1.227-1.167a.691.691,0,0,1,.271-.163.408.408,0,0,1,.459.215.383.383,0,0,1-.092.494c-.468.449-.939.894-1.409,1.34-.074.07-.146.144-.225.209a.39.39,0,0,1-.554-.019c-.29-.288-.577-.581-.857-.879a.425.425,0,0,1,0-.6.416.416,0,0,1,.6.038c.186.175.376.346.581.533",
    transform: "translate(-58.813 -259.002)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22180",
    "data-name": "Path 22180",
    d: "M62.215,172.115c.408-.389.833-.791,1.256-1.2a.424.424,0,0,1,.48-.121.4.4,0,0,1,.155.668c-.546.532-1.1,1.054-1.658,1.573a.375.375,0,0,1-.551-.018c-.286-.285-.569-.573-.846-.866a.413.413,0,1,1,.6-.563c.18.172.366.34.564.523",
    transform: "translate(-58.831 -164.919)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22181",
    "data-name": "Path 22181",
    d: "M62.231,366.756c.409-.389.836-.8,1.265-1.2a.411.411,0,0,1,.557-.065.391.391,0,0,1,.069.62q-.822.8-1.661,1.576a.374.374,0,0,1-.552-.022q-.423-.422-.836-.855a.415.415,0,1,1,.6-.566c.177.17.359.333.559.517",
    transform: "translate(-58.847 -352.894)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCipLease);
export default __webpack_public_path__ + "static/media/CIP_Lease.5b4c6f35e2d731477722af88708b4d0f.svg";
export { ForwardRef as ReactComponent };